import type { NavbarFolderItem, NavbarItem } from '../constant/navbar/NavbarItem';
import { NavbarItemTypeEnum } from '../constant/navbar/NavbarItem';

export function findSelectedNavbarFolderItem(items: NavbarItem[]): NavbarFolderItem | undefined {
  for (const item of items) {
    if (item.type === NavbarItemTypeEnum.Folder && item.selected) {
      return item;
    } else if (item.type === NavbarItemTypeEnum.Menu) {
      const result = findSelectedNavbarFolderItem(item.children);
      if (result) {
        return result;
      }
    }
  }

  return undefined;
}
